import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import { getProfile, getProfile_v2 } from '../utils/dropdownlist';

class PosUserForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      user_id: '',
      name: '',
      email: '',
      contact: '',
      role: '',
      profileId: '',
      userList: [],
      roleList: [],
      isGlobal: '',
      users: [],
      duplicateId: false,
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    if (this.state.isGlobal) {
      this.updateUser(user, url);
    } else {
      this.assignUser(user, comp, url);
    }
  };

  updateUser(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      user_id: this.props.data.userId,
      user_name: this.state.name,
      email: this.state.email,
      profile_id: this.state.profileId,
      update_by: user.email,
    };

    axios
      .post(url + ':3000/v1/user/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'User updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  assignUser(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      user_id: this.state.user_id,
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      added_by: user.email,
    };

    axios
      .post(url + ':3001/v1/store/user/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'User assigned successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  componentDidMount() {
    if (this.props.data.isGlobal) {
      //getProfile.call(this);
      this.getProfile();
      const user = this.props.data.userList.find(
        e => e.user_id === this.props.data.userId,
      );
      this.setState({
        profileId: user.profile_id,
        user_id: user.user_id,
        name: user.name,
        email: user.email,
        contact: user.contact,
        role: user.profile,
        isGlobal: this.props.data.isGlobal,
        users: this.props.data.useList,
      });
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      });
      this.getUserList();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getProfile() {
    getProfile_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
          }
          this.setState({
            roleList: result.data.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  getUserList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3000/v1/users', data)
      .then(response => {
        const result = response.data;
        const storeUser = this.props.data.userList;

        let UserOp = result.data.filter(
          x => !storeUser.some(y => y.user_id === x.user_id),
        );

        console.log(UserOp);
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ userList: UserOp });
      })
      .catch(error => {
        console.log(error);
        alert(error);
      });
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          User Information
        </ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="user_id">User ID</Label>
                  <Input
                    type="text"
                    name="user_id"
                    value={this.state.user_id}
                    readOnly
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Email</Label>
                  <Input
                    type="email"
                    name="email"
                    value={this.state.email}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="role">Role</Label>
                  <Input
                    type="select"
                    name="profileId"
                    value={this.state.profileId}
                    onChange={this.changeHandler}
                    required
                  >
                    <option value=""></option>
                    {this.state.roleList.length > 0 &&
                      this.state.roleList.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input
                    type="select"
                    name="user_id"
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    {this.state.userList.length > 0 &&
                      this.state.userList.map(item => {
                        return (
                          <option key={item.user_id} value={item.user_id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default PosUserForm;
